import { actions } from "common/store/collection";

export const NAMESPACE = "TAG/TAGS";

const tagActions = actions.factory(NAMESPACE);

export const { LOAD, LOAD_SUCCESS, LOAD_ERROR, CLEAR } = tagActions.TYPES;
export const CREATE = 'TAGS/TAG_CREATE';
export const CREATE_SUCCESS = 'TAGS/TAG_CREATE_SUCCESS';
export const CREATE_ERROR = 'TAGS/TAG_CREATE_ERROR';
export const SHOW_CREATE_TAG_DIALOG = 'TAGS/SHOW_CREATE_TAG_DIALOG';
export const SEARCH_TAGS_BY_LABEL = 'TAGS/SEARCH_TAGS_BY_LABEL';
export const SEARCH_TAGS_BY_LABEL_SUCCESS = 'TAGS/SEARCH_TAGS_BY_LABEL_SUCCESS';
export const SEARCH_TAGS_BY_LABEL_ERROR = 'TAGS/SEARCH_TAGS_BY_LABEL_ERROR';
export const EDIT = 'TAGS/TAG_EDIT';
export const EDIT_SUCCESS = 'TAGS/TAG_EDIT_SUCCESS';
export const EDIT_ERROR = 'TAGS/TAG_EDIT_ERROR';
export const DELETE = 'TAGS/TAG_DELETE';
export const DELETE_SUCCESS = 'TAGS/TAG_DELETE_SUCCESS';
export const DETACH = 'TAGS/TAG_DETACH';
export const DETACH_SUCCESS = 'TAGS/TAG_DETACH_SUCCESS';
export const DETACH_ERROR = 'TAGS/TAG_DETACH_ERROR';
export const SHOW_ATTACH_TAG_DIALOG = 'TAGS/SHOW_ATTACH_TAG_DIALOG';
export const ATTACH_TAG = 'TAGS/ATTACH_TAG';
export const ATTACH_TAG_SUCCESS = 'TAGS/ATTACH_TAG_SUCCESS';
export const ATTACH_TAG_ERROR = 'TAGS/ATTACH_TAG_ERROR';
export const CREATE_NEW_TAG_FROM_ATTACH_TAG_SUCCESS = 'CREATE_NEW_TAG_FROM_ATTACH_TAG_SUCCESS';
export const ATTACH_TAG_SEARCH_CLEARED = 'ATTACH_TAG_SEARCH_CLEARED';
export const HANDLE_DEVICE_TAGS_LOAD = 'HANDLE_DEVICE_TAGS_LOAD';

export const { loadSuccess, loadError, clear } = tagActions;

export const load = (pageNum, tagsData, isDelete, limit) => ({
  ...tagActions.load(),
  pageNum,
  tagsData,
  isDelete,
  limit
});

export const clearData = () => {
  return {
    type: "CLEAR_TAGS_DATA",
  };
};

export const searchTagsByLabel = (searchInfo, pageNum, tagsData, isDelete) => {
  return({
  type: SEARCH_TAGS_BY_LABEL,
  searchInfo,
  pageNum,
  tagsData: pageNum === 1? [] : tagsData,
  isDelete
});}

export const searchTagsByLabelSuccess = ({data, total, pageNumber}) => {
    return {
        type: SEARCH_TAGS_BY_LABEL_SUCCESS,
        data,
        total,
        pageNumber
    }
}

export const searchTagsByLabelError = (err) => {
    return {
        type: SEARCH_TAGS_BY_LABEL_ERROR,
    }
}

export const create = (tag , isAttchTag = false, limit) => ({
  type: CREATE,
  tag,
  isAttchTag,
  limit,
});

export const createSuccess = (tag) => ({
  type: CREATE_SUCCESS,
  tag,
});

export const createError = (err) => {
  return {
    type: CREATE_ERROR,
    error: err.message,
  };
};

export const showCreateTagDialog = (flag, isCreateFromAttach = false) => ({
  type: SHOW_CREATE_TAG_DIALOG,
  flag,
  isCreateFromAttach,
});

export const edit = (id, tag) => ({
  type: EDIT,
  id,
  tag,
});

export const editSuccess = (id, tag) => ({
  type: EDIT_SUCCESS,
  id,
  tag,
});

export const editError = err => ({
  type: EDIT_ERROR,
  error: err.message,
});

export const deleteTag = (id, pageNum, tagsData, searchText, searchTagPageNumber, limit) => { return{
  type: DELETE,
  id,
  pageNum,
  tagsData,
  searchText,
  searchTagPageNumber,
  limit,
};}

export const deleteSuccess = (id) => ({
  type: DELETE_SUCCESS,
  id,
});

export const detach = (detachInfo, isMeterTagHistory, uniqueId) => ({
  type: DETACH,
  detachInfo,
  isMeterTagHistory,
  uniqueId
});

export const detachSuccess = (detachedInfo) => ({
  type: DETACH_SUCCESS,
  detachedInfo,
});

export const detachError = (err) => {
  return {
    type: DETACH_ERROR,
    error: err.message,
  };
};

export const showAttchTagDialog = (flag, fromDeviceFilter=false) => ({
  type: SHOW_ATTACH_TAG_DIALOG,
  flag,
  fromDeviceFilter
});

export const attachTag = (attachTagInfo, tagDets) => {return({
    type: ATTACH_TAG,
    attachTagInfo,
    tagDets
});}

export const attachTagSuccess = (response, tagDets) => ({
  type: ATTACH_TAG_SUCCESS,
  payload: response,
  tagDets
});

export const attachTagError = (err) => ({
  type: ATTACH_TAG_ERROR,
  error: err.message
});

export const createNewTagFromAttachSuccess = (newTagId) => {
  return({
  type: CREATE_NEW_TAG_FROM_ATTACH_TAG_SUCCESS,
  newTagId
});}

export const attachTagSearchCleared = () => ({
  type: ATTACH_TAG_SEARCH_CLEARED,
});

export const handleDeviceTagsLoad = () => ({
  type: HANDLE_DEVICE_TAGS_LOAD
})
